/**
 * External Dependencies
 */
//import 'jquery';
//import 'bootstrap';
import { debounce } from "vue-debounce";

require("./bootstrap");
import store from "./store/index";
import { mapState, mapMutations } from "vuex";
import { library as FontAwesomeLibrary } from "@fortawesome/fontawesome-svg-core";
import { faYoutube } from "@fortawesome/free-brands-svg-icons";
import { faDiscord } from "@fortawesome/free-brands-svg-icons";
import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import { faXTwitter } from "@fortawesome/free-brands-svg-icons";
import { faTwitch } from "@fortawesome/free-brands-svg-icons";
import { faMagnifyingGlass as faSearchLight } from "@fortawesome/free-solid-svg-icons";
import { faGear } from "@fortawesome/free-solid-svg-icons";
import { faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { faTag } from "@fortawesome/free-solid-svg-icons";
import { faShieldHalved as faShieldAlt } from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

FontAwesomeLibrary.add(
	faYoutube,
	faDiscord,
	faFacebook,
	faXTwitter,
	faTwitch,
	faSearchLight,
	faTag,
	faShieldAlt,
	faGear,
	faArrowRightFromBracket,
);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component(
	"mobile-nav-panel",
	require("./components/global/MobileNavPanel.vue").default,
);
Vue.component(
	"youtube-trailer-switching",
	require("./components/slider/YoutubeTrailerSwitching.vue").default,
);

Vue.component(
	"hero-slider",
	require("./components/slider/HeroSlider.vue").default,
);

const app = new Vue({
	el: "#app",
	store,
	data: {
		isFixed: false,
		nav: null,
		scrollY: 0,
		ready: false,
		video: "",
		headerImg: "",
		headerImgTopMobile: "",
		headerImgBottomMobile: "",
	},

	created() {
		this.isMobileDevice();

		const isSafari = this.isSafari();
		this.storeIsSafari(isSafari);

		if (isSafari) {
			document.documentElement.classList.add("safari");
		} else {
			document.documentElement.classList.add("not-safari");
		}

		const isIE = this.isIE();
		this.$store.commit("storeIsIE", isIE);
		if (isIE) {
			document.documentElement.classList.add("ie");
		} else {
			document.documentElement.classList.add("not-ie");
		}

		this.$store.commit("storeIs4k", this.is4k());
	},

	mounted() {
		//console.log('this',this.$t('ui.knights.red-hood.title'))

		// this.$store.commit('storeSettings',window.__SETTINGS__);

		let self = this;

		window.onresize = debounce(() => {
			self.isMobileDevice();
		}, 200);

		$('[data-toggle="tooltip"]').tooltip({
			delay: 500,
			trigger: "hover",
		});

		const OS = this.getMobileOperatingSystem();

		this.storeShowIos(
			OS === null
				? true
				: OS === "Android"
					? false
					: OS === "iOS"
						? true
						: true,
		);
		this.storeShowAndroid(
			OS === null
				? true
				: OS === "Android"
					? true
					: OS === "iOS"
						? false
						: true,
		);

		// Test via a getter in the options object to see if the passive property is accessed
		/*
            let supportsPassive = false;
            try {
              let opts = Object.defineProperty({}, 'passive', {
                get: function() {
                  supportsPassive = true;
                }
              });
              window.addEventListener("testPassive", null, opts);
              window.removeEventListener("testPassive", null, opts);
            } catch (e) {}


            this.nav = document.querySelector('#MainNavigation');

            window.addEventListener('scroll', (event) => {
              self.scrollY = Math.round(window.scrollY);
            }, supportsPassive ? { passive: true } : false );


            this.ready = true;
        */

		/*

            let scroll = this.getParameterByName('scroll');
            //console.log('scroll',scroll);
            if( scroll !== null ){
              setTimeout(function(){

                let ele = $('#'+scroll);
                //console.log('ele',ele);
                if( ele.length ){
                  let pos = ele.offset().top - 40;
                  //console.log('pos',pos);
                  // animated top scrolling
                  $('body, html').animate({scrollTop: pos});
                }


              },1500);

            }*/
	},

	methods: {
		...mapMutations(["storeIsSafari", "storeShowIos", "storeShowAndroid"]),

		isMobileDevice() {
			let check = window.matchMedia(
				"only screen and (max-width: 991px)",
			).matches;
			store.commit("storeIsMobile", check);
			return check;
		},

		isIE() {
			var ua = window.navigator.userAgent;

			// Test values; Uncomment to check result …

			// IE 10
			// ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

			// IE 11
			// ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

			// Edge 12 (Spartan)
			// ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

			// Edge 13
			// ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

			var msie = ua.indexOf("MSIE ");
			if (msie > 0) {
				// IE 10 or older => return version number
				let check = parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
				if (check) {
					//this.lazyLoadInstance.update();
				}
				return check;
			}

			var trident = ua.indexOf("Trident/");
			if (trident > 0) {
				// IE 11 => return version number
				var rv = ua.indexOf("rv:");
				let check = parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
				if (check) {
					//this.lazyLoadInstance.update();
				}
				return check;
			}

			// var edge = ua.indexOf('Edge/');
			// if (edge > 0) {
			//     // Edge (IE 12+) => return version number
			//     return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
			// }

			// other browser
			return false;
		},

		is4k() {
			return window.matchMedia("only screen and (max-width: 2560px)").matches;
		},

		isSafari() {
			let ua = window.navigator.userAgent;
			let iOS = !!ua.match(/iP(ad|od|hone)/i);
			let hasSafariInUa = !!ua.match(/Safari/i);
			let noOtherBrowsersInUa = !ua.match(
				/Chrome|CriOS|OPiOS|mercury|FxiOS|Firefox/i,
			);
			let result = false;
			if (iOS) {
				//detecting Safari in IOS mobile browsers
				let webkit = !!ua.match(/WebKit/i);
				result = webkit && hasSafariInUa && noOtherBrowsersInUa;
			} else if (window.safari !== undefined) {
				//detecting Safari in Desktop Browsers
				result = true;
			} else {
				// detecting Safari in other platforms
				result = hasSafariInUa && noOtherBrowsersInUa;
			}
			return result;
		},

		modalCommonDisplay(newValue) {
			if (newValue) {
				setTimeout(() => {
					document.querySelector("body").classList.add("show-modal");
				}, 250);
			} else {
				document.querySelector("body").classList.remove("show-modal");
			}
		},

		getParameterByName(name, url) {
			if (!url) {
				url = window.location.href;
			}
			name = name.replace(/[\[\]]/g, "\\$&");
			var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
				results = regex.exec(url);
			if (!results) {
				return null;
			}
			if (!results[2]) {
				return "";
			}
			return decodeURIComponent(results[2].replace(/\+/g, " "));
		},

		getMobileOperatingSystem() {
			let userAgent = navigator.userAgent || navigator.vendor || window.opera;

			if (/android/i.test(userAgent)) {
				return "Android";
			}

			// iOS detection from: http://stackoverflow.com/a/9039885/177710
			if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
				return "iOS";
			}

			return null;
		},
	},

	computed: {
		...mapState(["showMobileMenu", "isMobile", "showIOS", "showAndroid"]),
	},

	watch: {
		isMobile(val) {
			if (val) {
				this.video = "/app/themes/got/dist/images/mobile-portrait.mp4";
				this.headerImgTopMobile =
					"/app/themes/got/dist/images/header-bg-sm-top.webp";
				this.headerImgBottomMobile =
					"/app/themes/got/dist/images/header-bg-sm-bottom.webp";
			} else {
				this.video = "/app/themes/got/dist/images/desktop.mp4";
				this.headerImg = "/app/themes/got/dist/images/header-bg.webp";
			}
		},

		showMobileMenu: function (newValue) {
			this.modalCommonDisplay(newValue);

			if (!newValue && this.scrollToAfterModalClose) {
				//   console.log('YES!!!',this.scrollToAfterModalClose);
				let e = document.getElementById(this.scrollToAfterModalClose);
				window.scrollTo({
					left: 0,
					top: e.offsetTop,
					behavior: "smooth",
				});

				this.storeScrollToAfterModalClose(null);
			}
		},

		scrollY(newValue) {
			// console.log('this.nav.offsetTop',this.nav.offsetTop, ': ',newValue);
			if (this.nav) {
				// this.isFixed = this.nav.offsetTop < newValue;
				this.isFixed = newValue > 40 && !this.showMobileMenu;
			}
		},
	},
});
